import {
  IncidentProduct,
  IncidentSchema,
  IncidentSeverity,
  IncidentStatus,
} from "@redotech/redo-model/incidents/incident";
import * as zExt from "@redotech/rpc/ext";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod";

export const getIncidents = {
  name: "getIncidents" as const,
  input: z.object({
    teamId: zExt.objectId().nullish(),
    status: createEnum(IncidentStatus).nullish(),
    severity: createEnum(IncidentSeverity).nullish(),
    type: createEnum(IncidentProduct).nullish(),
    isGlobal: z.boolean().nullish(),
    isTest: z.boolean().nullish(),
  }),
  output: z.object({ incidents: z.array(IncidentSchema), total: z.number() }),
};
